import { removeClassificationLink } from './getRemoveClassificationLink.locstring.json';
import loc from 'owa-localize';
import { InfoBarCustomAction } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import clearClassification from 'owa-mail-message-classification/lib/utils/clearClassification';
import ClassificationViewState from '../store/schema/ClassificationViewState';
import { InfoBarHostViewState } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';

export default function getRemoveClassificationLink(
    viewState: ClassificationViewState,
    infoBarViewState: InfoBarHostViewState,
    composeId: string
): InfoBarCustomAction {
    return {
        text: loc(removeClassificationLink),
        action: () => {
            clearClassification(viewState, infoBarViewState, composeId);
        },
    };
}
